import { FormObjects } from "../../../../../shared/core/utilities/formObjects";
import { ValidatorFn, FormGroup, Validators } from "@angular/forms";

export abstract class JpatsFormObjects extends FormObjects {
    static Wristband (initialValue: any = null, validators?: ValidatorFn[]): FormGroup {
        return new FormGroup({
            identifierNumber:FormObjects.String(initialValue ? initialValue.identifierNumber : '', [Validators.required]),
            patientKey: FormObjects.String(initialValue ? initialValue.patientKey : ''),
            metadataKey: FormObjects.String(initialValue ? initialValue.metadataKey : ''),
            hashCode: FormObjects.Number(initialValue ? initialValue.hashCode : 0),
            identifierType: FormObjects.Lookup(initialValue ? initialValue.identifierType : null)
        })
    }
}